import * as vp from 'vopay';

import axios from 'axios';

import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

const { api } = vopayApi;

export default function useFetchInterestAccounts() {
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const source = axios.CancelToken.source();

  async function fetchInterestAccounts(requestParams: vp.InterestAccountRequest) {
    try {
      setDataFetchingInfo(true);
      const res = await api.fetchInterestAccount(requestParams, source);
      return res;
    } finally {
      setDataFetchingInfo(false);
    }
  }

  return {
    fetchInterestAccounts,
  };
}
